export class ViewApplicationLocationRcConstants {
    static STEP_TITLE = "Location";
    static REMOVE_PROPERTY_LABEL = "Remove property";
    static ONLY_ONE_PROPERTY_ALLOWED = "only one property can be added per application.";
    static DESCRIPTION_LABEL_1 = "Search the map to find the property for which you are lodging an application, using the 'Find address or place' search bar.";
    static DESCRIPTION_LABEL_2 = "Zoom in close enough to the correct property and click on the property. Click on 'add property' in the window that appears on the map after you selected the property.";
    static DESCRIPTION_LABEL_3 = "The property will be added and the fields must be completed for the property. Please note that multiple properties may be added.";
    static DESCRIPTION_LABEL_4 = "Please note that the zoning here is the current zoning of the property. Please note that an owner should be added for each property (this is linked to the property and the application).";
    static ERF_NO_TEXT_PLACEHOLDER = "Erf no";
    static SUBDIVISION_TEXT_PLACEHOLDER = "Subdivision / portion number";
    static FARM_NO_TEXT_PLACEHOLDER = "Farm no";
    static ALLOTMENT_TEXT_PLACEHOLDER = "Allotment / suburb";
    static SG_CODE_TEXT_PLACEHOLDER = "SG Code";
    static ADDRESS_TEXT_PLACEHOLDER = "Address";
    static TITLE_DEED_NUMBER_LABEL = "Title deed number";
    static ZONING_LABEL = "Zoning";
    static SECTIONAL_TITLE_SCHEME_NAME_LABEL = "Sectional title scheme name";
    static SECTIONAL_TITLE_SCHEME_NUMBER_LABEL = "Sectional title scheme number";
    static SECTIONAL_TITLE_SCHEME_UNIT_LABEL = "Sectional title scheme unit";
    static EXTENT_LABEL = "Extent";
    static PURCHASE_PRICE_LABEL = "Purchase price";
    static DATE_OF_SALE_LABEL = "Date of sale";
    static ELECTRICITY_ACCOUNT_NUMBER_LABEL = "Electricity account number";
    static WATER_ACCOUNT_NUMBER_LABEL = "Water account number";
    static REFUSE_ACCOUNT_NUMBER_LABEL = "Refuse account number";
    static MANAGING_AGENT_LABEL = "Managing agent";
    static ERF_NO_CONTROL = "erfNo";
    static SUBDIVISION_CONTROL = "subdivision";
    static FARM_NO_CONTROL = "farmNo";
    static ALLOTMENT_CONTROL = "allotment";
    static SG_CODE_CONTROL = "sgCode";
    static ADDRESS_CONTROL = "address";
    static TITLE_DEED_NUMBER_CONTROL = "titleDeedNumber";
    static ZONING_CONTROL = "zoning";
    static SECTIONAL_TITLE_SCHEME_NAME_CONTROL = "sectionalTitleSchemeName";
    static SECTIONAL_TITLE_SCHEME_NUMBER_CONTROL = "sectionalTitleSchemeNumber";
    static SECTIONAL_TITLE_SCHEME_UNIT_CONTROL = "sectionalTitleSchemeUnit";
    static EXTENT_CONTROL = "extent";
    static PURCHASE_PRICE_CONTROL = "purchasePrice";
    static DATE_OF_SALE_CONTROL = "dateOfSale";
    static ELECTRICITY_ACCOUNT_NUMBER_CONTROL = "electricityAccountNumber";
    static WATER_ACCOUNT_NUMBER_CONTROL = "waterAccountNumber";
    static REFUSE_ACCOUNT_NUMBER_CONTROL = "refuseAccountNumber";
    static MANAGING_AGENT_CONTROL = "managingAgent";
    static DUPLICATE_MESSAGE = "The selected property has already been added";
    static TRUE_CENTROID = "True centroid gp shared-services";
    static INVALID_ZONING_ATTRIBUTE = "Zoning attribute is missing on the property zoning layer. Please contact your systems administrator.";
    static ZONING_NOT_FOUND = "The found zone ({0}) has not been configured in the lookups. Please contact your systems administrator.";
    static DATE_CONST = "yyyy-MM-dd";
    static PROPERTY_REQUIRED = "Please select a property before continuing with the create application process";
}
